import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';

const removeLinkedInstitution = async ({
  clientId,
  externalAccountId,
}: {
  clientId: string;
  externalAccountId?: string;
}) => {
  return authFetch('/Consumer/PlaidAccountsLinking/DeleteItem', {
    method: 'POST',
    ...httpBodyOptions({
      clientId,
      itemId: externalAccountId,
    }),
  });
};

export const useRemoveLinkedInstitution = () => {
  return useMutation(removeLinkedInstitution);
};
